import { COLORS, TYPE, SPACE } from './tokens'

export default function ReviewHistoryView() {
  return (
    <div style={{ padding: `48px ${SPACE.pagePadding}`, background: COLORS.bodyBg, minHeight: '100%' }}>
      <div style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
        <p style={{ ...TYPE.lead, color: COLORS.bodyText, marginBottom: '8px' }}>
          Review history
        </p>
        <p style={{ ...TYPE.body, color: COLORS.mutedText }}>
          Term-grouped history arrives in Phase 2b.
        </p>
      </div>
    </div>
  )
}
